import React from 'react'

function SvgPassword() {
  return (
    <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4999 16.793H16.4999M3.5 16.793L7.13832 16.0599C7.33147 16.021 7.50881 15.9259 7.6481 15.7865L15.7928 7.63734C16.1833 7.24663 16.1831 6.61331 15.7922 6.22292L14.0669 4.49952C13.6762 4.1093 13.0432 4.10957 12.6529 4.50012L4.5073 12.6502C4.36829 12.7892 4.27337 12.9662 4.23442 13.159L3.5 16.793Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
}

export default SvgPassword